import type { Logger } from '@vp/ubik-logging'

import type { PreviewInstructions } from '../types/PreviewInstructions'

export const getPreviewInstructions = async (url: string, logger: Logger): Promise<PreviewInstructions> => {
  try {
    const response = await fetch(url)

    if (!response.ok) {
      throw new Error(`Request to ${url} failed with status: ${response.status}`)
    }

    const data: PreviewInstructions = await response.json()
    return data
  } catch (error) {
    logger.error('Unable to retrieve preview instructions', error as Error, { url })
    throw error
  }
}
